import { webApiEndpoints } from "../config"
import { mapper } from "../helpers/mapper.helper"
import { CredentialType, NewCredentialType, AppCategories, AppRequestType, RepositoryType } from "../types"

const category: AppCategories = 'workspace'

export const workspaceAdapter = {
    getAll: (): AppRequestType<CredentialType[]>[typeof category]['getCredentials'] => ({
        endpoint: webApiEndpoints[category].getCredentials,
        input: null,
        keepCacheBeforeNewRequest: true,
        output: (datos) => datos.map(mapper.apiCredentials)
    }),
    addCredential: (data: NewCredentialType): AppRequestType<CredentialType>[typeof category]['addCredentials'] => ({
        endpoint: webApiEndpoints[category].addCredentials,
        input: ({
            workspace: data.workspace,
            descripcion: data.description,
            acceso: data.key,
            credencial: data.secret,
            codigo: data.initialCode
        }),
        output: (datos) => mapper.apiCredentials(datos)
    }),
    editCredential: (data: NewCredentialType): AppRequestType<CredentialType>[typeof category]['editCredentials'] => ({
        endpoint: webApiEndpoints[category].editCredentials,
        input: ({
            workspace: data.workspace,
            descripcion: data.description,
            acceso: data.key,
            credencial: data.secret,
            codigo: data.initialCode
        }),
        output: (datos) => mapper.apiCredentials(datos)
    }),
    deleteCredential: (data: CredentialType): AppRequestType<number>[typeof category]['deleteCredentials'] => ({
        endpoint: webApiEndpoints[category].deleteCredentials,
        input: ({
            id: data.id,
            workspace: data.workspace,
            descripcion: '',
            acceso: '',
            credencial: '',
            repositorios: [],
            fechaControl: '',
            usuarioModificador: '',
            token: ''
        }),
        output: (datos) => datos
    }),
    updateRepository: (data: RepositoryType, newRepo: boolean): AppRequestType<RepositoryType>[typeof category]['addRepository'] => ({
        endpoint: webApiEndpoints[category][newRepo ? 'addRepository' : 'editRepository'],
        input: ({
            id: data.id,
            idWorkspace: data.idWorkspace,
            nombre: data.name,
            descripcion: data.description,
            subtipo: data.subtype,
            rutaRepositorio: data.path,
            recursos: []
        }),
        output: (datos) => ({
            id: datos.id,
            idWorkspace: datos.idWorkspace || 0,
            description: datos.descripcion,
            name: datos.nombre,
            subtype: datos.subtipo,
            path: datos.rutaRepositorio,
        })
    }),
    deleteRepository: (data: RepositoryType): AppRequestType<number>[typeof category]['deleteRepository'] => ({
        endpoint: webApiEndpoints[category].deleteRepository,
        input: ({
            id: data.id,
            idWorkspace: data.idWorkspace,
            nombre: data.name,
            subtipo: data.subtype,
            descripcion: '',
            recursos: [],
            rutaRepositorio: ''
        }),
        output: (datos) => datos
    })
}